// Admin allowlist lives in Firestore (config/admins, field `emails`) instead
// of hardcoded in source, so Juan can add/remove admins from the Firebase
// Console directly without a code deploy.
import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebase";

export async function getAdminEmails() {
  const snap = await getDoc(doc(db, "config", "admins"));
  return snap.exists() ? snap.data().emails || [] : [];
}
